import { generalUrls } from '@/configs/urls'
import { FiFile } from 'react-icons/fi'

export const urlsByProcessType = {
  AI_METADATA: `/${generalUrls.licensed}`,
  AI_METADATA_BUILD_BATCH: `/${generalUrls.aiMetadataBatches}`,
  LICENSED_ASSETS_BATCH: `/${generalUrls.assetLicenseBatches}`
}
export const batchProcessStatus = {
  ERROR: 'error',
  FAILED: 'warning',
  PARTIAL: 'warning',
  PROCESSING: 'processing',
  SUCCESS: 'success'
}

export const getStatus = (status) => {
  return batchProcessStatus[status] || batchProcessStatus.PROCESSING
}

export const batchLabelByProcessType = {
  ASSET_LISTING_BATCH: 'Asset Listing Batch',
  ASSETS_BATCH_PROCESSING: 'Asset Batch',
  ASSETS_BATCH_CREATING: 'Asset Batch',
  SAM_BUILD_BATCH: 'SAM Build Batch'
}

export const itemLabelsByProcessType = {
  AI_METADATA: 'AI Metadata'
}

export const viewItemLabelByProcessType = {
  AI_METADATA_BUILD_BATCH: 'View AI Metadata Batch',
  LICENSED_ASSETS_BATCH: 'View Licensed Asset Batch',
  AI_METADATA: 'View Licensed Asset'
}

export const itemIconsByProcessType = {
  AI_METADATA: FiFile
}
